export default "__VITE_ASSET__xFsh4gUB__"